<template>
  <div class="pagination-v3">
    <div class="flex pagination-content">
      <div :class="[page < 11 ? 'is-disabled' : '', 'page-btn', 'beginning',]" @click="changePage(page - 10)"></div>
      <div :class="[page === 1 ? 'is-disabled' : '', 'page-btn', 'prev']" @click="changePage(page-1)"></div>
      <div class="flex pagination-info">
        <span>{{range}}</span>
        <span>of</span>
        <span>{{total}}</span>
      </div>
      <div :class="[page === maxPage || maxPage === 0 ? 'is-disabled' : '', 'page-btn', 'next']"  @click="changePage(page+1)"></div>
      <div :class="[page > maxPage - 10 ? 'is-disabled' : '', 'page-btn', 'ending']"  @click="changePage(page + 10)"></div>
    </div>
    <div class="page-size flex" v-if="hideSizeSelect">
      <span class="showRows">Show rows</span>
      <el-popover
        placement="top"
        width="67"
        v-model="showPageSize"
        popper-class="common-pagination-v3-size"
        trigger="click">
        <div class="common-pagination-v3-list">
          <ul>
            <li 
              @click="changeSize(item)"
              :class="[pageSize == item ? 'is_active' : '']"
              v-for="item in list"
              :key="item">{{item}}</li>
          </ul>
        </div>
        <div class="rows-size" slot="reference">{{pageSize}}</div>
      </el-popover>
    </div>
  </div>
</template>
<script>
export default {
  name: 'common-pagination-v3',
  data() {
    return {
      list: [20, 50, 100],
      showPageSize: false,
      pageSize: 20,
      page: 0,
      // selfPage: 0
    }
  },
  props: {
    total: {
      default: 0,
      type: Number
    },
    currentPage: {
      default: 1,
      type: Number
    },
    size: {
      default: 20,
      type: Number
    },
    hideSizeSelect: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    range() {
      let str = ''
      if (this.end !== undefined && this.start < this.end) {
        str = `${this.start}-${this.end}`
      }else if(this.end < this.start) {
         str = this.end
      } else {
        str = this.start
      }
      return str
    },
    maxPage() {
      return Math.ceil(this.total / this.pageSize)
    },
    start() {
      if (this.total == 0) return 0
      return (this.pageSize * (this.page - 1) + 1) > this.total ? (this.pageSize * this.maxPage + 1) : (this.pageSize * (this.page - 1) + 1)
    },
    end() {
      return this.page < this.maxPage ? this.pageSize * (this.page) : this.total
    }
  },
  watch: {
    size: {
      handler(val) {
        this.pageSize = val
      },
      immediate: true
    },
    currentPage: {
      handler() {
        this.page = this.currentPage < 1 ? 1 : this.currentPage
      },
      immediate: true
    }
  },
  methods: {
    changeSize(size) {
      console.log(size,this.pageSize,'101');
      this.showPageSize = false
      if(size === this.pageSize) return
      this.pageSize = size
      console.log(this.maxPage < this.page,this.maxPage, this.page,'105');
      if(this.maxPage < this.page) this.page = this.maxPage
      this.$emit('changeSize', size)
    },
    changePage(page){
      if (page < 1 || page > this.maxPage) return
      console.log(page)
      this.$emit('handleCurrentChange', page)
    }
  }
}
</script>
<style lang="scss" scoped>
.flex{
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination-v3{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .page-size{
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.pagination-content{
  height: 26px;
}
.beginning{
  background-image: url("~@/assets/img/com-2/6.svg");
  margin-right: 8px;
}
.prev{
  background-image: url("~@/assets/img/com-2/8.svg");
  margin-right: 20px;
}
.next{
  background-image: url("~@/assets/img/com-2/5.svg");
  margin-left: 20px;
}
.ending{
  background-image: url("~@/assets/img/com-2/7.svg");
  margin-left: 8px
}


.page-btn{
  @extend .flex;
  height: 100%;
  width: 26px;
  border-radius: 4px;
  // border: solid 1px #b2b6c0;
  cursor: pointer;
}
.is-disabled{
  border-color: #b2b6c0;

  &.beginning{
    background-image: url("~@/assets/img/com-2/2.svg");
  }
  &.prev{
    background-image: url("~@/assets/img/com-2/4.svg");
  }
  &.next{
    background-image: url("~@/assets/img/com-2/3.svg");
  }
  &.ending{
    background-image: url("~@/assets/img/com-2/1.svg");
  }
  
}

.pagination-info{
  span{
    font-family: OpenSans;
    color: #000;
    font-size: 12px;
  }
  span:first-child{
    margin-right: 4px;
  }
  span:last-child{
    margin-left: 4px;
    font-weight: bold;
    font-weight: bold;
  }
  
}

.showRows{
  font-weight: bold;
  color: #4c556c;
  font-size: 12px;
  font-weight: bold;
  margin-right: 10px;
}

.rows-size{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 8px;
  width: 67px;
  height: 26px;
  border-radius: 4px;
  cursor: pointer;
  color: #4066d4;
  font-weight: bold;
  font-size: 12px;
  border: solid 1px #b4bac8;
  background: url("~@/assets/img/com-2/icon-24-down.svg") no-repeat;
  background-position: center right;
}

</style>
<style lang="scss">
  .common-pagination-v3-size{
    min-width: auto !important;
    box-shadow: none !important;
    padding: 8px !important;
    transform: translateY(8px);
    z-index: 999999 !important;

    .popper__arrow{
      display: none !important;
    }
  }
  .common-pagination-v3-list{
    ul {
      width: 100%;
      li{
        padding-left: 10px;
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        font-family: OpenSans-Semibold;
        font-size: 12px;
        line-height: 16px;

        &:hover{
          border-radius: 4px;
          background-color: #f4f5f9;
        }

        &.is_active{
          color: #4066d4;
        }
      }
    }
  }
</style>
